import React from "react";
import { AddTemplateCategorySection } from "./Addtemplatecategorysection";

export const AddTemplateMarketingSection: React.FC = () => (
  <AddTemplateCategorySection category="MARKETING" />
);